// import { useEffect } from "react";

// function InstagramEmbed({ postUrl, width = "100%" }) {

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://www.instagram.com/embed.js";
//     script.async = true;
//     document.body.appendChild(script);

//     window.instgrm?.Embeds?.process();
//   }, [postUrl]);

//   return (
//     <blockquote
//       className="instagram-media"
//       data-instgrm-permalink={postUrl}
//       data-instgrm-version="14"
//       style={{ width, margin: "0 auto" }}
//     />
//   );
// }

// export default InstagramEmbed;

import { useEffect, useRef } from "react";

function InstagramEmbed({ postUrl, width = "100%" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!postUrl) return;

    const loadEmbed = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    };

    // Check if script already exists
    const existingScript = document.querySelector(
      'script[src="https://www.instagram.com/embed.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://www.instagram.com/embed.js";
      script.async = true;
      script.onload = loadEmbed;
      document.body.appendChild(script);
    } else {
      loadEmbed();
    }
  }, [postUrl]);

  return (
    <div ref={containerRef} style={{ width, margin: "0 auto" }}>
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={postUrl}
        data-instgrm-version="14"
        style={{ width: "100%" }}
      />
    </div>
  );
}

export default InstagramEmbed;
